import React from "react";
import { NavLink } from "react-router-dom";
import { NavContainer } from "./style";

export const MenuLinks = ( toggled, toggle) => {
  return (
    <NavContainer>
      <NavLink onClick={()=>{}} className="tracking-in-expand" to="/">
        Home
      </NavLink>
      <NavLink className="tracking-in-expand" to="/quem-sou">
        Quem Sou
      </NavLink>
      <NavLink className="tracking-in-expand" to="/servicos">
        Serviços
      </NavLink>
      <NavLink className="tracking-in-expand" to="/projetos">
        Projetos
      </NavLink>
      <NavLink className="tracking-in-expand" to="/contatos">
        Contatos
      </NavLink>
    </NavContainer>
  );
};
